import {isDev} from "../utils/util"
import {CardClickActionData} from "../components/Card/card"

export interface State {
    dialogList: any[]
    sessionId: string
    serverHost: string
    adaptWindow: boolean
    appId: string
    welcome: string
    model: Model
    disableDragging: boolean
    showFpIframe: boolean
    showFpType: string
    newPortal: boolean
    fpInvokeData: CardClickActionData
    fpParam: object
    showInContainer: boolean
}

export interface Model {
    invoke: (key: string, value: any) => void
}

export interface Dispatch {
    (action: Action): void
}

export interface Action {
    type: ActionType
    payload?: any
}

export type ActionType =
    | "addNewInput"
    | "addNewAnswer"
    | "resetSession"
    | "initParam"
    | "initModel"
    | "updateDraggingState"
    | "showFpIframe"

export const reducer = (state: State, action: Action): State => {
    // isDev(() => {
    //     console.log(state)
    //     console.log(`action is : `, action)
    //     console.count("----------------------")
    // })
    let payload = action.payload
    switch (action.type) {
        case "addNewInput":
            return {
                ...state,
                dialogList: [
                    ...state.dialogList,
                    {
                        type: "input",
                        content: payload.text,
                    },
                ],
            }
        case "addNewAnswer":
            return {
                ...state,
                dialogList: [
                    ...state.dialogList,
                    {
                        type: "answer",
                        content: payload.data,
                    },
                ],
            }
        case "resetSession":
            return {
                ...state,
                dialogList: [],
            }
        case "initParam":
            return {
                ...state,
                ...payload,
            }
        case "initModel":
            return {
                ...state,
                model: payload,
            }
        case "updateDraggingState":
            return {
                ...state,
                disableDragging: payload,
            }
        case "showFpIframe":
            return {
                ...state,
                showFpType: payload.type,
                fpParam: payload.param,
                showFpIframe: payload.status,
                fpInvokeData: payload.fpInvokeData,
            }
        default:
            return {
                ...state,
            }
    }
}
